// extracted by mini-css-extract-plugin
export default {"side-menu":"SideMenu_side-menu__zq8sT"};